import { render } from "./InfoCollector.vue?vue&type=template&id=124b5b7f"
import script from "./InfoCollector.vue?vue&type=script&lang=js"
export * from "./InfoCollector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__